import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { LABEL_TEXT } from './tokens';

export interface RadioOption {
  readonly value: string;
  readonly label: string;
  readonly description?: string;
}

interface RadioGroupProps {
  readonly label?: string;
  readonly options: readonly RadioOption[];
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly disabled?: boolean;
  readonly name?: string;
  readonly orientation?: 'vertical' | 'horizontal';
}

export function RadioGroup({
  label,
  options,
  value,
  onChange,
  disabled,
  name,
  orientation = 'vertical',
}: RadioGroupProps) {
  const listClass =
    orientation === 'horizontal'
      ? 'flex flex-row flex-wrap gap-3'
      : 'flex flex-col gap-3';

  return (
    <div>
      {label && <div className={`${LABEL_TEXT} mb-2`}>{label}</div>}
      <RadixRadioGroup.Root
        value={value}
        onValueChange={onChange}
        disabled={disabled}
        name={name}
        orientation={orientation}
      >
        <div className={listClass}>
          {options.map((option) => (
            <div key={option.value} className="flex flex-row items-start gap-2.5">
              <RadixRadioGroup.Item
                value={option.value}
                id={`${name ?? 'radio'}-${option.value}`}
                className="w-4 h-4 rounded-full border border-slate-200 bg-white data-[state=checked]:border-blue-600 flex items-center justify-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 shrink-0 mt-0.5"
              >
                <RadixRadioGroup.Indicator className="w-2 h-2 rounded-full bg-blue-600" />
              </RadixRadioGroup.Item>
              <label
                htmlFor={`${name ?? 'radio'}-${option.value}`}
                className="flex flex-col"
              >
                <span className="text-sm text-slate-700">{option.label}</span>
                {option.description && (
                  <span className="text-sm text-slate-500">{option.description}</span>
                )}
              </label>
            </div>
          ))}
        </div>
      </RadixRadioGroup.Root>
    </div>
  );
}
